export const REQUIRED = 'This section cannot be empty';
